import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';
import TypeChip from '../../chip/TypeChip';
import FormError from '../../form-error/FormError';
import { ExerciseType, Simulator, SimulatorType } from '../../types';

export interface SimulatorFieldProps {
  control: Control<any>;
  simulators: Simulator[];
  name: string;
  exerciseType: ExerciseType;
}

const SimulatorField = ({ control, simulators, name, exerciseType }: SimulatorFieldProps) => {
  const {
    field,
    fieldState: { error },
    formState,
  } = useController({ control, name, rules: { required: 'Please select a simulator' } });

  // For classroom exercises, only show/allow cloud simulators
  const filteredSimulators =
    exerciseType === ExerciseType.Classroom
      ? simulators?.filter(simulator => simulator.type === SimulatorType.Cloud)
      : simulators;

  useEffect(() => {
    if (simulators && field.value && !simulators.some(simulator => simulator.id === field.value)) {
      field.onChange('');
    }
  });

  useEffect(() => {
    if (simulators && field.value && !simulators.some(simulator => simulator.id === field.value)) {
      // Reset
      field.onChange('');
    }
  }, [simulators]);

  return (
    <FormControl fullWidth error={!!error}>
      <InputLabel>Simulator</InputLabel>

      <Select {...field} label="Simulator" required data-cy="select-simulator">
        {(filteredSimulators ?? []).map(({ id, name, type }) => (
          <MenuItem key={id} value={id} data-cy={`select-option-${name}`}>
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              {name}
              <TypeChip size="small" type={type} />
            </Box>
          </MenuItem>
        ))}
      </Select>

      <FormError name="simulator" formState={formState} />
    </FormControl>
  );
};

export default SimulatorField;
